import _extends from "babel-runtime/helpers/extends";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import glamorous from "glamorous";

var RsIconSpan = glamorous.span({
  display: "inline-block",
  userSelect: "none",
  userDrag: "none",

  WebkitTouchCallout: "none",
  WebkitUserSelect: "none",
  KhtmlUserSelect: "none",
  MozUserSelect: "none",
  MsUserSelect: "none",
  WebkitUserDrag: "none",

  "& span": {
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    display: "inline-block"
  },

  "& .innerText": {
    pointerEvents: "none"
  }
});

export var RsIcon = function (_PureComponent) {
  _inherits(RsIcon, _PureComponent);

  function RsIcon() {
    var _temp, _this, _ret;

    _classCallCheck(this, RsIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.shouldDisplayNumber = function () {
      return _this.state.hover && _this.props.navnumber || _this.props.ico === "PathstepCurrent";
    }, _this.getDynamicStyles = function () {
      var cssObj = {};

      if (_this.props.widthheight) {
        cssObj["width"] = _this.props.widthheight + "px";
        cssObj["height"] = _this.props.widthheight + "px";
      }

      var iconStyles = _this.props.iconStyle;
      var mergedStyles = iconStyles ? _extends({}, cssObj, iconStyles) : cssObj;

      if (_this.props.useStyles) {
        // Mapping has styles instead of class names.
        mergedStyles = _extends({}, mergedStyles, _this.props.mapping[_this.props.ico]);
      }

      return mergedStyles;
    }, _this.state = {
      hover: false
    }, _this.mouseOver = function () {
      _this.setState({ hover: true });
    }, _this.mouseOut = function () {
      _this.setState({ hover: false });
    }, _this.numberOffset = function () {
      // If we shrink down the icon, we need to offset the text to keep it centered on the background icon.
      var offsets = {
        22: { fontSize: "13px", top: "-1px", position: "relative" },
        21: { fontSize: "13px", top: "-1px", position: "relative" },
        20: { fontSize: "12px", top: "-2px", position: "relative" },
        19: { fontSize: "12px", top: "-2px", position: "relative" },
        18: { fontSize: "11px", top: "-3px", position: "relative" },
        17: { fontSize: "10px", top: "-4px", position: "relative" },
        16: { fontSize: "10px", top: "-4px", position: "relative" },
        15: { fontSize: "10px", top: "-4px", position: "relative" },
        14: { fontSize: "9px", top: "-5px", position: "relative" },
        13: { fontSize: "9px", top: "-5px", position: "relative" }
      };
      return offsets[_this.props.widthheight] || null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RsIcon.prototype.getClassName = function getClassName() {
    // mapping passed in string for this.props.ico
    // to css class in RsIcon.css
    if (this.props.useStyles) {
      return "";
    }
    return this.props.mapping[this.props.ico];
  };

  RsIcon.prototype.render = function render() {
    return React.createElement(
      RsIconSpan,
      {
        className: "rs-icon",
        style: this.props.style,
        onClick: this.props.onClick,
        "data-qa": "RSIcon-" + this.props.ico + "-" + (this.props.navnumber || 0)
      },
      this.getClassName() || this.props.useStyles ? React.createElement(
        "span",
        {
          style: this.getDynamicStyles(),
          onMouseOver: this.mouseOver,
          onMouseOut: this.mouseOut,
          className: this.getClassName()
        },
        this.shouldDisplayNumber() ? React.createElement(
          "span",
          { className: "innerText", style: this.numberOffset() },
          this.props.navnumber
        ) : "\xA0"
      ) : null
    );
  };

  return RsIcon;
}(PureComponent);

RsIcon.propTypes = {
  style: PropTypes.object,
  ico: PropTypes.string,
  onClick: PropTypes.func,
  widthheight: PropTypes.number,
  useStyles: PropTypes.bool,
  navnumber: PropTypes.number
};

RsIcon.defaultProps = {
  useStyles: false
};

export default RsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-common-ui/es/RsIcon.js
// module id = 635
// module chunks = 0